import gql from 'graphql-tag'

export const listUsers = gql`
	fragment listUsers on UserConnection {
		items {
			id
			code
			name
			isActive
		}
		cursors {
			hasNext
			hasPrevious
			before
			after
		}
		hasNextPage
		total
	}
`

export const user = gql`
	fragment usermain on User {
		name
		printName
		shortName
		code
		codeExtern
		isActive
		password
		performance
		timeTrackingId
		isPasswordOnlyForLogin
		shopId
		img {
			uid
			key
		}
		dateInterval {
			to
			from
		}
	}
`

export const permissions = gql`
	fragment permissions on User {
		isAdmin
		isManager
		isFinStatements
		isDayFinStatements
		isViewSales
		isTimeTracking
		isOnlyNonManagerTables
		typeRFID
		cancelationPermissions
	}
`
